import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { classes, TooltipStyles } from './Tooltip.style';

const Tooltip = forwardRef(({ title, text, buttonText, onButtonClick, position = 'left', isVisible }, ref) => {
  if (!isVisible) return null;
  return (
    <div ref={ref} className={`${classes.container} ${position}`}>
      {TooltipStyles}
      <div className={classes.title}>{title}</div>
      <div className={classes.text}>{text}</div>
      <button type="button" className={classes.button} data-testid="tooltip-button" onClick={onButtonClick}>
        {buttonText}
      </button>
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  position: PropTypes.oneOf(['left', 'right', 'top']),
  isVisible: PropTypes.bool.isRequired,
};

Tooltip.defaultProps = {
  position: 'left',
};

export default Tooltip;
